module.exports = __webpack_public_path__ + "img/mini-code.12524ce2.svg";